import { createStyles, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { Body } from 'copilot-design-system';
import { useChannelStateContext, useTypingContext } from 'stream-chat-react';

// TODO in POR-15598: move useChatClient out of legacy
// eslint-disable-next-line no-restricted-imports
import { useChatClient } from 'src/legacy/components/Chat/useChatClient';

const useStyles = makeStyles(() =>
  createStyles({
    one: {
      opacity: 0,
      WebkitAnimation: '$dot 1.3s infinite',
      WebkitAnimationDelay: '0.0s',
      animation: '$dot 1.3s infinite',
      animationDelay: '0.0s',
    },
    two: {
      opacity: 0,
      WebkitAnimation: '$dot 1.3s infinite',
      WebkitAnimationDelay: '0.2s',
      animation: '$dot 1.3s infinite',
      animationDelay: '0.2s',
    },
    three: {
      opacity: 0,
      WebkitAnimation: '$dot 1.3s infinite',
      WebkitAnimationDelay: '0.3s',
      animation: '$dot 1.3s infinite',
      animationDelay: '0.3s',
    },
    '@keyframes dot': {
      '0%': { opacity: 0 },
      '50%': { opacity: 0 },
      '100%': { opacity: 1 },
    },
  }),
);

const textClasses = 'font-medium leading-6';
const containerClasses = 'flex ml-3 items-center xs:mb-7';

export const ChannelTypingIndicator = () => {
  const classes = useStyles();
  const { channelConfig } = useChannelStateContext();
  const chatClient = useChatClient();
  const { typing = {} } = useTypingContext();

  if (channelConfig?.typing_events === false) {
    return null;
  }

  const typingInChannel = Object.values(typing).filter(
    ({ user }) => user?.id !== chatClient?.user?.id,
  );

  const renderAnimatingDots = () => (
    <>
      <Body
        className={clsx('text-gray-small', textClasses, classes.one)}
        size="sm"
        tag="div"
      >
        .
      </Body>
      <Body
        className={clsx('text-gray-small', textClasses, classes.two)}
        size="sm"
        tag="div"
      >
        .
      </Body>
      <Body
        className={clsx('text-gray-small', textClasses, classes.three)}
        size="sm"
        tag="div"
      >
        .
      </Body>
    </>
  );

  return (
    <>
      {typingInChannel && typingInChannel.length === 1 && (
        <div className={containerClasses}>
          <Body className={textClasses} size="sm" tag="div">
            {`${typingInChannel.at(0)?.user?.name}`}
          </Body>
          &nbsp;
          <Body className="leading-5 text-gray-small" size="sm" tag="div">
            is typing
          </Body>
          {renderAnimatingDots()}
        </div>
      )}

      {typingInChannel && typingInChannel.length > 1 && (
        <div className={containerClasses}>
          <Body className={textClasses} size="sm" tag="div">
            Multiple people
          </Body>
          &nbsp;
          <Body className="leading-5 text-gray-small" size="sm" tag="div">
            are typing
          </Body>
          {renderAnimatingDots()}
        </div>
      )}
    </>
  );
};
